import { z } from 'zod';

import {
  weeklyStatusCountsSchema,
  weeklyStatusTransitionSchema,
  weeklySummarySchema,
} from './weeklySummary';

export const adminProjectWeeklySummarySchema = weeklySummarySchema
  .pick({
    projectId: true,
    weekStartDate: true,
    weekEndDate: true,
    previousWeekStartDate: true,
    totalSensors: true,
    currentCounts: true,
    previousCounts: true,
    activeGatewayCount: true,
    totalGatewayCount: true,
    newRedSensorLocalIds: true,
    allRedSensorLocalIds: true,
    statusTransitions: true,
  })
  .extend({
    projectName: z.string(),
  });

export const adminProjectWeeklySummaryAlertProjectSchema = z.object({
  projectId: z.number(),
  projectName: z.string(),
  weekStartDate: z.string(),
  count: z.number(),
  sensorLocalIds: z.array(z.string()),
});

export const adminProjectWeeklyStatusCountsSchema = z.object({
  weekStartDate: z.string(),
  weekEndDate: z.string(),
  counts: weeklyStatusCountsSchema,
});

export const adminPortfolioWeeklySummarySchema = z.object({
  weekStartDate: z.string(),
  weekEndDate: z.string(),
  previousWeekStartDate: z.string(),
  totalSensors: z.number(),
  currentCounts: weeklyStatusCountsSchema,
  previousCounts: weeklyStatusCountsSchema,
  activeGatewayCount: z.number(),
  totalGatewayCount: z.number(),
  statusTransitions: z.array(weeklyStatusTransitionSchema),
  projectsWithNewRedSensors: z.array(adminProjectWeeklySummaryAlertProjectSchema),
  projectsWithRedSensors: z.array(adminProjectWeeklySummaryAlertProjectSchema),
});

export const adminProjectWeeklySummaryKpiResponseSchema = z.object({
  summaries: z.array(adminProjectWeeklySummarySchema),
  portfolioSummaries: z.array(adminPortfolioWeeklySummarySchema).default([]),
  currentCounts: weeklyStatusCountsSchema,
  previousCounts: weeklyStatusCountsSchema,
  weeklyStatusCounts: z.array(adminProjectWeeklyStatusCountsSchema),
  statusTransitions: z.array(weeklyStatusTransitionSchema),
  projectsWithNewRedSensors: z.array(adminProjectWeeklySummaryAlertProjectSchema),
  projectsWithRedSensors: z.array(adminProjectWeeklySummaryAlertProjectSchema),
});

export type AdminProjectWeeklySummaryKpiResponse = z.infer<
  typeof adminProjectWeeklySummaryKpiResponseSchema
>;
export type AdminProjectWeeklySummaryAlertProject = z.infer<
  typeof adminProjectWeeklySummaryAlertProjectSchema
>;
export type AdminPortfolioWeeklySummary = z.infer<typeof adminPortfolioWeeklySummarySchema>;
